module.exports = __webpack_public_path__ + "static/media/detail_img1.9af382bb.jpg";